/*const swiper = new Swiper('.mega-menu__item.swiper', {
  loop: true,
  slidesPerView: 1.5,
  loopAdditionalSlides: 1,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  on: {
    init: function () {
      const nextArrow = document.querySelector('.swiper-button-next');
      const prevArrow = document.querySelector('.swiper-button-prev');
      prevArrow.style.display = 'none';
      if (this.isEnd) {
        // nextArrow.style.display = 'none';
      } else {
        nextArrow.style.display = 'block';
      }
    },
    slideChangeTransitionStart: function () {
      const nextArrow = document.querySelector('.swiper-button-next');
      const prevArrow = document.querySelector('.swiper-button-prev');
      if (this.isEnd) {
        nextArrow.style.display = 'none';
      } else {
        nextArrow.style.display = 'block';
      }
      if (this.isBeginning) {
        prevArrow.style.display = 'none';
      } else {
        prevArrow.style.display = 'block';
      }
    },
  },
});*/
const swiper = new Swiper('.mega-menu__item.swiper', {
  loop: true,
  slidesPerView: 2,
  loopAdditionalSlides: 1,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  on: {
    init: function () {
      const nextArrow = document.querySelector('.swiper-button-next');
      const prevArrow = document.querySelector('.swiper-button-prev');
      prevArrow.style.display = 'none';
      if (this.isEnd) {
        // nextArrow.style.display = 'none';
      } else {
        nextArrow.style.display = 'block';
      }
    },
    slideChangeTransitionStart: function () {
      const nextArrow = document.querySelector('.swiper-button-next');
      const prevArrow = document.querySelector('.swiper-button-prev');
      if (this.isEnd) {
        nextArrow.style.display = 'none';
      } else {
        nextArrow.style.display = 'block';
      }
      if (this.isBeginning) {
        prevArrow.style.display = 'none';
      } else {
        prevArrow.style.display = 'block';
      }
    },
  },
});




// const body = document.querySelector("body");
// const megaMenus = document.querySelectorAll("mega-menu");

// if (megaMenus) {
//   megaMenus.forEach(mm => {
//     let timeoutId;
    
//     mm.addEventListener("mouseover", () => {
//       clearTimeout(timeoutId); // Clear any previous timeout
//       body.classList.add("mega-menu-active");
//     });
    
//     mm.addEventListener("mouseleave", () => {
//       timeoutId = setTimeout(() => {
//         body.classList.remove("mega-menu-active");
//       }, 3000); 
//     });
//   });
// }
const body = document.querySelector("body");
const megaMenus = document.querySelectorAll("mega-menu"); // Use class selector

if (megaMenus) {
  megaMenus.forEach(mm => {
    let timeoutId;

    mm.addEventListener("mouseover", () => {
      clearTimeout(timeoutId);
      body.classList.add("mega-menu-active");
    });

    mm.addEventListener("mouseleave", () => {
      // Check if the mouse is not over the "mega-menu" element, including padding
      if (!isMouseOverElementWithPadding(mm)) {
        timeoutId = setTimeout(() => {
          body.classList.remove("mega-menu-active");
        }, 3000);
      }
    });
  });
}

// Function to check if the mouse is over an element, including padding
function isMouseOverElementWithPadding(element) {
  const rect = element.getBoundingClientRect();
  const padding = 10; // Adjust the padding value as needed
  return (
    event.clientX >= rect.left - padding &&
    event.clientX <= rect.right + padding &&
    event.clientY >= rect.top - padding &&
    event.clientY <= rect.bottom + padding
  );
}




